export class PriceFormatter {
    //Rounds to 2 decimals, eg. 1,234.567 -> 1234.56
    round = (num) => Math.round((num + Number.EPSILON) * 100) / 100;

    //Rounds to 2 decimals, returns plain number with commas. eg "1,234.56"
    format(value) {
        const num = typeof value === "string" ? parseFloat(value) : value;

        if (isNaN(num)) return "0.00";

        const rounded = this.round(num);
        return new Intl.NumberFormat().format(rounded);
    }

    //Rounds to 2 decimals, formats as THB currency with code THB. eg "THB 1,234.56"
    formatCurrency(value) {
        const num = typeof value === "string" ? parseFloat(value) : value;

        if (isNaN(num)) return "0.00";

        const rounded = this.round(num);
        return new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "THB"
        }).format(rounded);
    }

    // Rounds to 2 decimals, formats as THB currency with symbol ฿. eg "฿1,234.56"
    formatSymbolCurrency(value) {
        const num = typeof value === "string" ? parseFloat(value) : value;

        if (isNaN(num)) return "฿0.00";

        const rounded = this.round(num);
        return new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "THB"
        })
            .format(rounded)
            .replace("THB", "฿")
            .replace(/\s+/g, "");
    }
}

